import React from 'react';

const renderSpreedlyScript = () =>
  typeof window !== 'undefined' &&
  !(window as any).Spreedly && <script async src="https://core.spreedly.com/iframe/iframe-stable.min.js" />;

export default renderSpreedlyScript;
